export default __webpack_public_path__ + "static/media/need-help-women.61d04bfd.png";